import { literal, object, string } from 'valibot';

import { GOOGLE_ADS_ACTION_UPDATE_PTO_ADS } from './constants';

export const updatePtoAdsDataSchema = object({
  mobilePtoCreative: string(),
  mobilePtoUrl: string(),
});

export const updatePtoAdsSchema = object({
  type: literal(GOOGLE_ADS_ACTION_UPDATE_PTO_ADS),
  data: updatePtoAdsDataSchema,
});
